// Fixed-height layout of the search terms grid (ExploreTable pattern).
export const NB_GRID_HEIGHT = 600;
export const GROUP_HEADER_H = 22;
export const COLUMN_HEADER_H = 36;
export const HEADER_H = GROUP_HEADER_H + COLUMN_HEADER_H;
export const ROW_H = 44;
export const TOOLBAR_H = 40;
export const FOOTER_H = 53;

/**
 * While the rows fit under NB_GRID_HEIGHT the grid sizes itself (autoHeight); beyond, fixed height + internal scroll.
 * The header bar and the footer sit inside the capped box too.
 */
export const fitsWithoutCap = (rowCount: number) =>
  TOOLBAR_H + HEADER_H + rowCount * ROW_H + FOOTER_H <= NB_GRID_HEIGHT;
